namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemExDt2Columns {
        static columnsKey = 'AdvPromo.Adv05ItemExDt';
    }
}
